import { URL_CHANGED, UrlState, UrlAction } from './url.action';

/** Url reducer. */
export const urlReducer = <TParams = Record<string, any>>(
    state: UrlState<TParams> & { history: UrlState<TParams>[] } = { path: '', params: {} as TParams, hash: {}, history: [] },
    action: UrlAction<TParams>,
) => {
    switch (action.type) {
        case URL_CHANGED:
            return {
                ...action.payload,
                history: [action.payload, ...state.history].slice(0, 100),
            };

        default:
            return state;
    }
};
